module.exports = __webpack_public_path__ + "static/media/20_000009.bd3b31c8.jpg";